const translation = {
  currentPlan: 'Plan Actuel',
  upgradeBtn: {
    plain: 'Mettre à jour le plan',
    encourage: 'Mettre à niveau maintenant',
    encourageShort: 'Mise à niveau',
  },
  viewBilling: 'Gérer la facturation et les abonnements',
  buyPermissionDeniedTip: 'Veuillez contacter votre administrateur d\'entreprise pour vous abonner',
  plansCommon: {
    title: 'Choisissez un plan qui vous convient',
    yearlyTip: 'Obtenez 2 mois gratuitement en vous abonnant annuellement !',
    mostPopular: 'Le Plus Populaire',
    planRange: {
      monthly: 'Mensuel',
      yearly: 'Annuel',
    },
    month: 'mois',
    year: 'année',
    save: 'Enregistrer',
    free: 'Gratuit',
    currentPlan: 'Plan Actuel',
    contractSales: 'Contactez les ventes',
    contractOwner: 'Contacter le chef d\'équipe',
    startForFree: 'Commencez gratuitement',
    getStartedWith: 'Commencez avec',
    contactSales: 'Contacter les ventes',
    talkToSales: 'Parlez aux Ventes',
    modelProviders: 'Fournisseurs de Modèles',
    teamMembers: 'Membres de l\'équipe',
    buildApps: 'Construire des Applications',
    vectorSpace: 'Espace Vectoriel',
    vectorSpaceBillingTooltip: 'Chaque 1MB peut stocker environ 1,2 million de caractères de données vectorisées (estimé en utilisant les embeddings OpenAI, varie selon les modèles).',
    vectorSpaceTooltip: 'L\'espace vectoriel est le système de mémoire à long terme nécessaire pour que les LLMs comprennent vos données.',
    documentsUploadQuota: 'Quota de téléchargement de documents',
    documentProcessingPriority: 'Priorité de Traitement de Document',
    documentProcessingPriorityTip: 'Pour une priorité de traitement de documents plus élevée, veuillez mettre à niveau votre plan.',
    documentProcessingPriorityUpgrade: 'Traitez plus de données avec une précision plus élevée à des vitesses plus rapides.',
    priority: {
      'standard': 'Standard',
      'priority': 'Priorité',
      'top-priority': 'Priorité Maximale',
    },
    logsHistory: 'Historique des logs',
    customTools: 'Outils personnalisés',
    unavailable: 'Indisponible',
    days: 'jours',
    unlimited: 'Illimité',
    support: 'Assistance',
    supportItems: {
      communityForums: 'Forums communautaires',
      emailSupport: 'Support par email',
      priorityEmail: 'Support prioritaire par email et chat',
      logoChange: 'Changement de logo',
      SSOAuthentication: 'Authentification SSO',
      personalizedSupport: 'Soutien personnalisé',
      dedicatedAPISupport: 'Support dédié pour l\'API',
      customIntegration: 'Intégration personnalisée et support',
      ragAPIRequest: 'Requêtes API RAG',
      bulkUpload: 'Téléchargement en masse de documents',
      agentMode: 'Mode Agent',
      workflow: 'Flux de travail',
      llmLoadingBalancingTooltip: 'Ajoutez plusieurs clés API aux modèles, en contournant efficacement les limites de débit de l’API.',
      llmLoadingBalancing: 'Équilibrage de charge LLM',
    },
    comingSoon: 'Bientôt disponible',
    member: 'Membre',
    memberAfter: 'Membre',
    messageRequest: {
      title: 'Crédits de message',
      tooltip: 'Quotas d\'invocation de messages pour divers plans utilisant les modèles OpenAI (sauf gpt4). Les messages dépassant la limite utiliseront votre clé API OpenAI.',
      titlePerMonth: '{{count,number}} messages/mois',
    },
    annotatedResponse: {
      title: 'Limites de quota d\'annotation',
      tooltip: 'L\'édition manuelle et l\'annotation des réponses fournissent des capacités de réponse aux questions de haute qualité personnalisables pour les applications. (Applicable uniquement dans les applications de chat)',
    },
    ragAPIRequestTooltip: 'Fait référence au nombre d\'appels API invoquant uniquement les capacités de traitement de la base de connaissances de Dify.',
    receiptInfo: 'Seuls le propriétaire de l\'équipe et l\'administrateur de l\'équipe peuvent s\'abonner et consulter les informations de facturation',
    annotationQuota: 'Quota d’annotation',
    apiRateLimitUnit: '{{count,number}}/jour',
    priceTip: 'par espace de travail/',
    freeTrialTipSuffix: 'Aucune carte de crédit requise',
    teamWorkspace: '{{count,number}} Espace de travail d\'équipe',
    teamMember_one: '{{count,number}} membre de l\'équipe',
    annualBilling: 'Facturation Annuelle',
    self: 'Auto-hébergé',
    documentsRequestQuota: '{{count,number}}/min Limite de Fréquence de Demande de Connaissance',
    teamMember_other: '{{count,number}} Membres de l\'équipe',
    getStarted: 'Commencer',
    unlimitedApiRate: 'Pas de limite de taux d\'API',
    cloud: 'Service cloud',
    documentsTooltip: 'Quota sur le nombre de documents importés à partir de la source de données de connaissance.',
    freeTrialTip: 'essai gratuit de 200 appels OpenAI.',
    freeTrialTipPrefix: 'Inscrivez-vous et obtenez un',
    apiRateLimit: 'Limite de taux de l\'API',
    comparePlanAndFeatures: 'Comparer les plans et les fonctionnalités',
    apiRateLimitTooltip: 'La limite de taux de l\'API s\'applique à toutes les demandes effectuées via l\'API Dify, y compris la génération de texte, les conversations de chat, les exécutions de flux de travail et le traitement de documents.',
    documents: '{{count,number}} Documents de connaissance',
    documentsRequestQuotaTooltip: 'Spécifie le nombre total d\'actions qu\'un espace de travail peut effectuer par minute dans la base de connaissances, y compris la création, la suppression, les mises à jour de jeux de données, le téléchargement de documents, les modifications, l\'archivage et les requêtes de la base de connaissances. Ce paramètre est utilisé pour évaluer les performances des requêtes de la base de connaissances. Par exemple, si un utilisateur de Sandbox effectue 10 tests de validité consécutifs en une minute, son espace de travail sera temporairement restreint dans l\'exécution des actions suivantes pendant la minute suivante : création, suppression, mises à jour de jeux de données, et téléchargements ou modifications de documents.',
  },
  plans: {
    sandbox: {
      name: 'Bac à sable',
      description: '200 essais gratuits de GPT',
      includesTitle: 'Inclus :',
      for: 'Essai gratuit des fonctionnalités principales',
    },
    professional: {
      name: 'Professionnel',
      description: 'Pour les individus et les petites équipes afin de débloquer plus de puissance à un prix abordable.',
      includesTitle: 'Tout ce qui est dans le plan gratuit, plus :',
      for: 'Pour les développeurs indépendants / petites équipes',
    },
    team: {
      name: 'Équipe',
      description: 'Collaborez sans limites et profitez d\'une performance de premier ordre.',
      includesTitle: 'Tout ce qui est inclus dans le plan Professionnel, plus :',
      for: 'Pour les équipes de taille moyenne',
    },
    enterprise: {
      name: 'Entreprise',
      description: 'Obtenez toutes les capacités et le support pour les systèmes à grande échelle et critiques pour la mission.',
      includesTitle: 'Tout ce qui est inclus dans le plan Équipe, plus :',
      features: {
        5: 'SLA négociés par Dify Partners',
        1: 'Autorisation de Licence Commerciale',
        2: 'Fonctionnalités exclusives pour les entreprises',
        4: 'SSO',
        8: 'Support Technique Professionnel',
        3: 'Gestion de plusieurs espaces de travail et d\'entreprise',
        6: 'Sécurité et contrôles avancés',
        7: 'Mises à jour et maintenance par Dify Officiellement',
        0: 'Solutions de déploiement évolutives de niveau entreprise',
      },
      for: 'Pour les équipes de grande taille',
      btnText: 'Contacter les ventes',
      priceTip: 'Facturation Annuel Seulement',
      price: 'Personnalisé',
    },
    community: {
      features: {
        2: 'Conforme à la licence open source de Dify',
        1: 'Espace de travail unique',
        0: 'Toutes les fonctionnalités principales publiées dans le référentiel public',
      },
      name: 'Communauté',
      btnText: 'Commencez avec la communauté',
      for: 'Pour les utilisateurs individuels, les petites équipes ou les projets non commerciaux',
      includesTitle: 'Fonctionnalités gratuites :',
      price: 'Gratuit',
      description: 'Pour les utilisateurs individuels, les petites équipes ou les projets non commerciaux',
    },
    premium: {
      features: {
        3: 'Support par e-mail et chat prioritaire',
        1: 'Espace de travail unique',
        0: 'Fiabilité autogérée par divers fournisseurs de cloud',
        2: 'Personnalisation du logo et de la marque de l\'application Web',
      },
      for: 'Pour les organisations et les équipes de taille moyenne',
      includesTitle: 'Tout de la communauté, en plus :',
      name: 'Premium',
      description: 'Pour les organisations et les équipes de taille moyenne',
      comingSoon: 'Support de Microsoft Azure et Google Cloud bientôt disponible',
      btnText: 'Obtenez Premium dans',
      price: 'Scalable',
      priceTip: 'Basé sur le marché des nuages',
    },
  },
  vectorSpace: {
    fullTip: 'L\'espace vectoriel est plein.',
    fullSolution: 'Mettez à niveau votre plan pour obtenir plus d\'espace.',
  },
  apps: {
    fullTipLine1: 'Mettez à jour votre plan pour',
    fullTipLine2: 'construire plus d\'applications.',
    fullTip2: 'Limite de plan atteinte',
    contactUs: 'Contactez-nous',
    fullTip1: 'Mettez à niveau pour créer plus d\'applications',
    fullTip2des: 'Il est recommandé de nettoyer les applications inactives pour libérer de l\'espace d\'utilisation, ou de nous contacter.',
    fullTip1des: 'Vous avez atteint la limite de création d\'applications avec ce plan.',
  },
  annotatedResponse: {
    fullTipLine1: 'Mettez à niveau votre plan pour',
    fullTipLine2: 'annotez plus de conversations.',
    quotaTitle: 'Quota de Réponse d\'Annotation',
  },
  usagePage: {
    buildApps: 'Construire des applications',
    vectorSpace: 'Stockage de données de connaissance',
    vectorSpaceTooltip: 'Les documents avec le mode d\'indexation de haute qualité utiliseront des ressources de stockage de données de connaissance. Lorsque le stockage de données de connaissance atteindra la limite, de nouveaux documents ne pourront pas être téléchargés.',
    teamMembers: 'Membres de l\'équipe',
    annotationQuota: 'Quota d\'annotation',
    documentsUploadQuota: 'Quota de téléchargement de documents',
  },
  teamMembers: 'Membres de l\'équipe',
}

export default translation
